import { Folder } from "domain/entities/folders.entities";
import { MouseEvent } from "react";
import { HiFolder } from "react-icons/hi";
import { useWindowWidth } from "ui/utils/hooks";

interface IProps {
  folder: Folder;
  onClick: () => void;
  row?: boolean;
}

export function FolderCard({ folder, onClick, row }: IProps) {
  const isDesktop = useWindowWidth();

  const handleCardClick = (e: MouseEvent) => {
    e.stopPropagation();
    if (onClick) onClick();
  };

  return (
    <div
      className={`rounded-2xl bg-secondaryGrey-500 ${
        onClick ? "cursor-pointer" : ""
      } ${row ? "flex flex-row items-center gap-3 p-3" : "p-4"}`}
      onClick={handleCardClick}
    >
      <div className={`$h-8 w-8 ${row ? "" : "mb-3"}`}>
        <div
          className={`flex h-8 w-8 items-center justify-center rounded-lg bg-darkGrey-300 md:h-12 md:w-12 md:rounded-xl`}
        >
          <HiFolder size={isDesktop ? 24 : 20} color="#485585" />
        </div>
      </div>
      <p className="text-sm font-medium text-secondaryGrey-900 md:text-lg">
        {folder.label}
      </p>
    </div>
  );
}
